import React, {useEffect, useMemo, useState} from 'react';
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import { connect } from 'react-redux';
import { Actions as CREATEACCOUNTACTIONS } from '../store/actions/createAccountActions';
import { Actions as WEBINARACTIONS } from '../store/actions/webinarActions';
import LeadForm from '../components/common/LeadForm'

import { useParams } from "react-router";
import { format, addMinutes } from "date-fns";

import AddToCalendarHOC from 'react-add-to-calendar-hoc';

import 'react-add-to-calendar/dist/react-add-to-calendar.css'

import ArticleCard from '../components/article/ArticleCard';
import PaymentConfirmationModal from 'components/common/PaymentConfirmationModal';
import SeoHeaders from "../components/SeoHeaders";

const EMAILLIST = 9

function Articles({
    userInList,
    contactInList,
    profile,
    articles,

}) {

    let { slug, country } = useParams();

    const articlesThisLang = useMemo(() => {
        return articles.filter(article => article.country.includes(country))
    }, [country]);

    useEffect(() => {
        if (profile && profile.email) {
            contactInList({
                email: profile.email,
            })
        }
    }, [profile && profile.email]);
    
    return (

        <React.Fragment>

            <SeoHeaders
                title={`HR & Payroll Articles | Buddy`}
                description={"Buddy Payroll & HR blog covers all payroll aspects for SMEs & Large Businesses. It includes blogs on Notice Period, Taxes, Benefits & Work Regulations."}
            />
            <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
                <div className="mx-auto max-w-screen-xl">
                    <div className="lg:grid lg:grid-cols-12 lg:gap-8">
                        <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
                            <div>                      
                                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                                    Discover the Nuances of Payroll
                                    <br />
                                    <span className="text-orange-400">with Buddy</span>
                                </h1>
                                <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                                    Learn key aspects of Payroll & HR through an array of in-depth articles
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <div className="relative py-16 bg-white overflow-hidden">
                <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:h-full lg:w-full">
                    <div className="relative h-full text-lg max-w-prose mx-auto">
                        <svg className="absolute top-12 left-full transform translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
                            <defs>
                                <pattern id="74b3fd99-0a6f-4271-bef2-e80eeafdf357" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                                    <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width="404" height="384" fill="url(#74b3fd99-0a6f-4271-bef2-e80eeafdf357)" />
                        </svg>
                        <svg className="absolute top-1/2 right-full transform -translate-y-1/2 -translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
                            <defs>
                                <pattern id="f210dbf6-a58d-4871-961e-36d5016a0f49" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                                    <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width="404" height="384" fill="url(#f210dbf6-a58d-4871-961e-36d5016a0f49)" />
                        </svg>
                        <svg className="absolute bottom-12 left-full transform translate-x-32" width="404" height="384" fill="none" viewBox="0 0 404 384">
                            <defs>
                                <pattern id="d3eb07ae-5182-43e6-857d-35c643af9034" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
                                    <rect x="0" y="0" width="4" height="4" className="text-gray-200" fill="currentColor" />
                                </pattern>
                            </defs>
                            <rect width="404" height="384" fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)" />
                        </svg>
                    </div>
                </div>
                <div className="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-12 lg:pb-28 lg:px-8">
                    <div className="absolute inset-0">
                        <div className="bg-white h-1/3 sm:h-2/3"></div>
                    </div>
                    <div className="relative max-w-7xl mx-auto">
                        <div className="mt-0 grid gap-5 max-w-lg mx-auto lg:grid-cols-3 lg:max-w-none">
                        {articlesThisLang.map(articles => (
                            <ArticleCard article={articles} country={country}/>
                        ))}
                        </div>
                    </div>
                </div>
            </div>
            <PaymentConfirmationModal />
        </React.Fragment>

    );
}

const mapStateToProps = (state) => {

    const profile = state && state.my && state.my.profile || localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))

    const userInList = state.createAccount && state.createAccount.inList && state.createAccount.inList.find(item => item == EMAILLIST)

    const articles = state.articles

    return {
        articles,
        userInList,
        profile
    }
}

const mapDispatchToProps = dispatch => ({
    contactInList: (data) => dispatch(CREATEACCOUNTACTIONS.contactInList(data)),
    addTag: (data) => dispatch(CREATEACCOUNTACTIONS.addTag(data)),
    setWebinar: (webinar) => dispatch(WEBINARACTIONS.setWebinar(webinar))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Articles)